export function nameValidator(name) {
  if (!name) return "Nama tidak boleh kosong."
  return ''
}
